import "./ServiceAndLocation.module.css";
import Header from "@/reusable_sections/Header";
import CommercialRepairServices from "./sections/CommercialRepairServices";
import OurLocations from "./sections/OurLocations";
import CallToAction from "./sections/CallToAction";
import Footer from "@/reusable_sections/Footer";
export default function ServiceAndLocationPage() {
  return <div>
      <Header />
      <CommercialRepairServices />
      <OurLocations />
      <CallToAction />
      <Footer />
    </div>;
}